import React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/react';

//TODO: Codespliting
import StartPage from './pages/StartPage';
import ImpressumPage from './pages/Impressum';
import AGBPage from './pages/AGB';
import DatenschutzPage from './pages/Datenschutz';
import WiderrufsrechtPage from './pages/Widerrufsrecht';
import BatterieentsorgungPage from './pages/Batterieentsorgung';
import KontaktPage from './pages/Kontakt';
import UeberUnsPage from './pages/UeberUns';
import KundeWerdenPage from './pages/KundeWerden';
import LoginPage from './pages/Login';
import DerBUCHBUTLER from './pages/DerBUCHBUTLER';
import VersandkostenPage from './pages/Versandkosten';
import VersandkostenAuslandPage from './pages/Versandkosten/Ausland';
import LogistikPage from './pages/Logistik';
import ZahlungPage from './pages/Zahlung';
import PartnerPage from './pages/Partner';

import SearchPage from './pages/SearchPage';
import ProductInfo from './pages/ProductInfo';
import ShoppingCart from './pages/ShoppingCart';

import Checkout_VRPage from './pages/Checkout_VR';
import CheckoutPage from './pages/Checkout';
import PaymentResultPage from './pages/PaymentStatus';
import KontoPage from './pages/Konto';
import LibripartnerPage from './pages/Libripartner';
import FAQPage from './pages/FAQ';
import HowToStartPage from './pages/HowToStart';
import BestPage from './pages/Best';
import Onlyb2bPage from './pages/UeberUns/onlyb2b';
import VersandkostenAllPage from './pages/Versandkosten/Versand_all';

export interface ReactRouterProps {
  apiData: any;
  mode: string;
  renderingUrl: string;
  postRenderControl?: any;
}

interface ReactRouterState {
  mode: string;
  apiUrl: string;
}

export default class ReactRouter extends React.Component<
  ReactRouterProps,
  ReactRouterState
> {
  constructor(props: any) {
    super(props);

    //debugger;

    this.state = { mode: props.mode, apiUrl: props.apiData.domainPrefix };
  }

  componentDidMount() {
    if (this.state.mode != 'react')
      if (this.state.mode != 'hot')
        setTimeout(() => {
          this.setState({ mode: 'react' });
        }, 1000);
  }

  getDynamicParams(props: any) {
    let apiData = null;

    if (this.state.mode == 'ssr' || this.state.mode == 'hydrate') {
      apiData = this.props.apiData;
    }

    let dynProps = {
      ...props,
      apiData: apiData,
      apiUrl: this.state.apiUrl,
      mode: this.state.mode,
      renderingUrl: this.props.renderingUrl,
      postRenderControl: this.props.postRenderControl,
    };
    return dynProps;
  }

  render() {
    //const SentryRoute = Sentry.withSentryRouting(Route);
    let pageItem = (
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => {
            return <StartPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/impressum"
          render={(props) => {
            return <ImpressumPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/agb"
          render={(props) => {
            return <AGBPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/datenschutz"
          render={(props) => {
            return <DatenschutzPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/widerrufsrecht"
          render={(props) => {
            return <WiderrufsrechtPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/batterieentsorgung"
          render={(props) => {
            return <BatterieentsorgungPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/kontakt"
          render={(props) => {
            return <KontaktPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/ueberuns"
          render={(props) => {
            return <UeberUnsPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/kundewerden"
          render={(props) => {
            return <KundeWerdenPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/login"
          render={(props) => {
            return <LoginPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/DerBUCHBUTLER"
          render={(props) => {
            return <DerBUCHBUTLER {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/versandkosten"
          render={(props) => {
            return <VersandkostenPage {...this.getDynamicParams(props)} />;
          }}
          exact={true}
        />
        <Route
          path="/versandkosten/:land"
          render={(props) => {
            return (
              <VersandkostenAuslandPage {...this.getDynamicParams(props)} />
            );
          }}
        />
        <Route
          path="/versandkosten_all"
          render={(props) => {
            return (
              <VersandkostenAllPage {...this.getDynamicParams(props)} />
            );
          }}
        />
        <Route
          path="/logistik"
          render={(props) => {
            return <LogistikPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/product_info/:products_id"
          render={(props) => {
            return <ProductInfo {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/search_page/"
          render={(props) => {
            return <SearchPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/shopping_cart/"
          render={(props) => {
            return <ShoppingCart {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/checkout_VR/"
          render={(props) => {
            return <Checkout_VRPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/checkout/"
          render={(props) => {
            return <CheckoutPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/paymentResult/"
          render={(props) => {
            return <PaymentResultPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/zahlung/"
          render={(props) => {
            return <ZahlungPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/partner/"
          render={(props) => {
            return <PartnerPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/konto/"
          children={(props) => {
            return <KontoPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/libripartner"
          children={(props) => {
            return <LibripartnerPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/faq"
          children={(props) => {
            return <FAQPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/howToStart"
          children={(props) => {
            return <HowToStartPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/onlyb2b"
          children={(props) => {
            return <Onlyb2bPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/best"
          children={(props) => {
            return <BestPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/check"
          render={(props) => {
            return <div>OK</div>;
          }}
        />
        <Route
          path="/"
          render={(props) => {
            debugger;
            return <Redirect to="/" />;
          }}
        />
      </Switch>
    );

    return pageItem;
  }
}
